module.exports = __webpack_public_path__ + "static/get_together-c6eb2d179480aa41ace63d323513d449.jpg";